/* tslint:disable */
/* eslint-disable */
/**
 * Tanagra Service API
 * github.com/DataBiosphere/tanagra
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FeatureSetCreateInfo
 */
export interface FeatureSetCreateInfo {
    /**
     * Name of the underlay, immutable
     * @type {string}
     * @memberof FeatureSetCreateInfo
     */
    underlayName?: string;
    /**
     * Human readable name of the feature set
     * @type {string}
     * @memberof FeatureSetCreateInfo
     */
    displayName?: string;
    /**
     * Description of the feature set
     * @type {string}
     * @memberof FeatureSetCreateInfo
     */
    description?: string;
}

/**
 * Check if a given object implements the FeatureSetCreateInfo interface.
 */
export function instanceOfFeatureSetCreateInfo(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FeatureSetCreateInfoFromJSON(json: any): FeatureSetCreateInfo {
    return FeatureSetCreateInfoFromJSONTyped(json, false);
}

export function FeatureSetCreateInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FeatureSetCreateInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'underlayName': !exists(json, 'underlayName') ? undefined : json['underlayName'],
        'displayName': !exists(json, 'displayName') ? undefined : json['displayName'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function FeatureSetCreateInfoToJSON(value?: FeatureSetCreateInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'underlayName': value.underlayName,
        'displayName': value.displayName,
        'description': value.description,
    };
}

